import * as Api from '../api';

const api = process.env.REACT_APP_ONB_API;

export const getSalesRanks = Api.get({ path: '/api/v1/sales-ranks', api });
